// CJK部首補助(U+2E80〜U+2EFF)の文字を、見た目が同じ通常の漢字に戻すための変換表。
// 康熙部首(U+2F00〜)は Unicode 正規化(NFKC)で通常の漢字に戻るが、CJK部首補助の多くは戻らないため、
// Unicode の EquivalentUnifiedIdeograph.txt(Unicode 18.0)から、NFKC で戻らない文字だけを取り出した。
// 例: 「⺠」(U+2EA0) → 「民」(U+6C11)。Mac で作られたPDFから文字を取り出すと、この種の文字が混ざることがある。

/** [CJK部首補助のコードポイント, 通常の漢字のコードポイント] */
const TABLE: ReadonlyArray<readonly [number, number]> = [
  [0x2e81, 0x5382], // ⺁ → 厂
  [0x2e82, 0x4e5b], // ⺂ → 乛
  [0x2e83, 0x4e5a], // ⺃ → 乚
  [0x2e84, 0x4e59], // ⺄ → 乙
  [0x2e85, 0x4ebb], // ⺅ → 亻
  [0x2e86, 0x5182], // ⺆ → 冂
  [0x2e87, 0x20628], // ⺇ → 𠘨
  [0x2e88, 0x5200], // ⺈ → 刀
  [0x2e89, 0x5202], // ⺉ → 刂
  [0x2e8a, 0x535c], // ⺊ → 卜
  [0x2e8b, 0x353e], // ⺋ → 㔾
  [0x2e8c, 0x5c0f], // ⺌ → 小
  [0x2e8d, 0x5c0f], // ⺍ → 小
  [0x2e8e, 0x5140], // ⺎ → 兀
  [0x2e8f, 0x5c23], // ⺏ → 尣
  [0x2e90, 0x5c22], // ⺐ → 尢
  [0x2e91, 0x21bc2], // ⺑ → 𡯂
  [0x2e92, 0x5df3], // ⺒ → 巳
  [0x2e93, 0x5e7a], // ⺓ → 幺
  [0x2e94, 0x5f51], // ⺔ → 彑
  [0x2e95, 0x2b739], // ⺕ → 𫜹
  [0x2e96, 0x5fc4], // ⺖ → 忄
  [0x2e97, 0x5fc3], // ⺗ → 心
  [0x2e98, 0x624c], // ⺘ → 扌
  [0x2e99, 0x6535], // ⺙ → 攵
  [0x2e9b, 0x65e1], // ⺛ → 旡
  [0x2e9c, 0x65e5], // ⺜ → 日
  [0x2e9d, 0x6708], // ⺝ → 月
  [0x2e9e, 0x6b7a], // ⺞ → 歺
  [0x2ea0, 0x6c11], // ⺠ → 民
  [0x2ea1, 0x6c35], // ⺡ → 氵
  [0x2ea2, 0x6c3a], // ⺢ → 氺
  [0x2ea3, 0x706c], // ⺣ → 灬
  [0x2ea4, 0x722b], // ⺤ → 爫
  [0x2ea5, 0x722b], // ⺥ → 爫
  [0x2ea6, 0x4e2c], // ⺦ → 丬
  [0x2ea7, 0x725b], // ⺧ → 牛
  [0x2ea8, 0x72ad], // ⺨ → 犭
  [0x2ea9, 0x738b], // ⺩ → 王
  [0x2eaa, 0x24d14], // ⺪ → 𤴔
  [0x2eab, 0x76ee], // ⺫ → 目
  [0x2eac, 0x793a], // ⺬ → 示
  [0x2ead, 0x793b], // ⺭ → 礻
  [0x2eae, 0x25ad7], // ⺮ → 𥫗
  [0x2eaf, 0x7cf9], // ⺯ → 糹
  [0x2eb0, 0x7e9f], // ⺰ → 纟
  [0x2eb1, 0x7f53], // ⺱ → 罓
  [0x2eb2, 0x7f52], // ⺲ → 罒
  [0x2eb3, 0x34c1], // ⺳ → 㓁
  [0x2eb4, 0x5197], // ⺴ → 冗
  [0x2eb5, 0x2626b], // ⺵ → 𦉫
  [0x2eb6, 0x7f8a], // ⺶ → 羊
  [0x2eb7, 0x2634c], // ⺷ → 𦍌
  [0x2eb8, 0x2634b], // ⺸ → 𦍋
  [0x2eb9, 0x8002], // ⺹ → 耂
  [0x2eba, 0x8080], // ⺺ → 肀
  [0x2ebb, 0x807f], // ⺻ → 聿
  [0x2ebc, 0x8089], // ⺼ → 肉
  [0x2ebd, 0x26951], // ⺽ → 𦥑
  [0x2ebe, 0x8279], // ⺾ → 艹
  [0x2ebf, 0x8279], // ⺿ → 艹
  [0x2ec0, 0x8279], // ⻀ → 艹
  [0x2ec1, 0x864e], // ⻁ → 虎
  [0x2ec2, 0x8864], // ⻂ → 衤
  [0x2ec3, 0x8980], // ⻃ → 覀
  [0x2ec4, 0x897f], // ⻄ → 西
  [0x2ec5, 0x89c1], // ⻅ → 见
  [0x2ec6, 0x89d2], // ⻆ → 角
  [0x2ec7, 0x278b2], // ⻇ → 𧢲
  [0x2ec8, 0x8ba0], // ⻈ → 讠
  [0x2ec9, 0x8d1d], // ⻉ → 贝
  [0x2eca, 0x27fb7], // ⻊ → 𧾷
  [0x2ecb, 0x8f66], // ⻋ → 车
  [0x2ecc, 0x8fb6], // ⻌ → 辶
  [0x2ecd, 0x8fb6], // ⻍ → 辶
  [0x2ece, 0x8fb6], // ⻎ → 辶
  [0x2ecf, 0x9091], // ⻏ → 邑
  [0x2ed0, 0x9485], // ⻐ → 钅
  [0x2ed1, 0x9577], // ⻑ → 長
  [0x2ed2, 0x9578], // ⻒ → 镸
  [0x2ed3, 0x957f], // ⻓ → 长
  [0x2ed4, 0x95e8], // ⻔ → 门
  [0x2ed5, 0x28e0f], // ⻕ → 𨸏
  [0x2ed6, 0x961d], // ⻖ → 阝
  [0x2ed7, 0x96e8], // ⻗ → 雨
  [0x2ed8, 0x9752], // ⻘ → 青
  [0x2ed9, 0x97e6], // ⻙ → 韦
  [0x2eda, 0x9875], // ⻚ → 页
  [0x2edb, 0x98ce], // ⻛ → 风
  [0x2edc, 0x98de], // ⻜ → 飞
  [0x2edd, 0x98df], // ⻝ → 食
  [0x2ede, 0x2967f], // ⻞ → 𩙿
  [0x2edf, 0x98e0], // ⻟ → 飠
  [0x2ee0, 0x9963], // ⻠ → 饣
  [0x2ee1, 0x29810], // ⻡ → 𩠐
  [0x2ee2, 0x9a6c], // ⻢ → 马
  [0x2ee3, 0x9aa8], // ⻣ → 骨
  [0x2ee4, 0x9b3c], // ⻤ → 鬼
  [0x2ee5, 0x9c7c], // ⻥ → 鱼
  [0x2ee6, 0x9e1f], // ⻦ → 鸟
  [0x2ee7, 0x5364], // ⻧ → 卤
  [0x2ee8, 0x9ea6], // ⻨ → 麦
  [0x2ee9, 0x9ec4], // ⻩ → 黄
  [0x2eea, 0x9efe], // ⻪ → 黾
  [0x2eeb, 0x6589], // ⻫ → 斉
  [0x2eec, 0x9f50], // ⻬ → 齐
  [0x2eed, 0x6b6f], // ⻭ → 歯
  [0x2eee, 0x9f7f], // ⻮ → 齿
  [0x2eef, 0x7adc], // ⻯ → 竜
  [0x2ef0, 0x9f99], // ⻰ → 龙
  [0x2ef1, 0x9f9c], // ⻱ → 龜
  [0x2ef2, 0x4e80], // ⻲ → 亀
];

export const CJK_RADICAL_SUPPLEMENT = new Map<string, string>(
  TABLE.map(([from, to]) => [String.fromCodePoint(from), String.fromCodePoint(to)]),
);
